export const SkillList = [
    {
      skill: 'Go',
      details: 'Experienced skills in back end development using Golang gRPC and GraphQL as back end.',
      level: 8
    },
    {
      skill: 'Python',
      details: 'Experienced using Python as programming language for AI and backend development',
      level: 7
    },
    {
      skill: 'Back End Development',
      details: 'Experienced skills in back end development making REST API using Next.js, ASP.NET, and Go.',
      level: 8
    },
    {
      skill: 'Postgresql',
      details: 'Experienced skills in making queries with Postgresql integrated with Golang Chi, gRPC, and GraphQL as back end.',
      level: 7
    },
    {
      skill: 'MySQL',
      details: 'Experienced skills in making queries with MySQL.',
      level: 8
    },
    {
      skill: 'SQL Server',
      details: 'Fundamental skills in making queries with SQL Server.',
      level: 6
    },
    {
      skill: 'Elasticsearch',
      details: 'Experienced skill in using Elasticsearch as a powerful, open-source, distributed search and analytics engine.',
      level: 7
    },
    {
      skill: 'WebSocket',
      details: 'Experienced skill in creating and building live persistent connection using WebSocket',
      level: 8
    },
    {
      skill: 'REST API',
      details: 'Experienced skills in back end development making REST API with Go, Python, Next.js, and ASP.NET.',
      level: 8
    },
    {
      skill: 'gRPC',
      details: 'Experienced skill in creating and building protobuf microservices.',
      level: 8
    },
    {
      skill: 'GraphQL',
      details: 'Experienced skill in creating and building GraphQL microservices.',
      level: 8
    },
    {
      skill: 'Redis Queue',
      details: 'Experienced skill in distributed system that utilize redis queue for queueing and processing jobs on background in another worker module',
      level: 7
    },
    {
      skill: 'Redis',
      details: 'Experienced skill in caching handling from repetitive input and output',
      level: 7
    },
    {
      skill: 'Docker',
      details: 'Experienced in containerizing distributed systems with a focus on security hardening, persistent storage volumes, and seamless CI/CD pipeline integration',
      level: 7
    },
    {
      skill: 'Kubernetes',
      details: 'Fundamental in deploying and load balancing microservices using GKE in Google Cloud Platform',
      level: 4
    },
    {
      skill: 'Kafka',
      details: 'Experience building high traffic application gateway using Kafka as messaging brokers',
      level: 7
    },
    {
      skill: 'GKE',
      details: 'Fundamental in deploying cluster that used for running application on the top of Kubernetes Engine.',
      level: 4
    },
    {
      skill: 'GCP',
      details: 'Fundamental in utilizing cloud platform for utilize Google Maps API, Gemini API, and GKE',
      level: 4
    },
    {
      skill: 'Internet of Things (IoT)',
      details: 'Fundamental skill in managing microservices-based architecture that use location tracking, supported by a network of 20.000+ GPS-enabled IoT (Internet Of Things) devices.',
      level: 3
    },
    {
      skill: 'React',
      details: 'In my role as a web developer, I have developed strong skills in React, enabling me to build dynamic, efficient, and scalable user interfaces.',
      level: 4
    },
    {
      skill: 'Next.js',
      details: 'Developed strong front end skills in Next.js and fundamental in back end routing API, optimizing SSR and SSG website rendering',
      level: 4
    },
    {
      skill: 'TypeScript',
      details: 'Strong skills in TypeScript, enabling the building of interactive and dynamic web applications.',
      level: 4
    },
    {
      skill: 'JavaScript',
      details: 'Strong skills in JavaScript, enabling the building of interactive and dynamic web applications.',
      level: 4
    },
    {
      skill: 'Front End Development',
      details: 'Strong front end skills by having great work experiences.',
      level: 4
    },
    {
      skill: 'Software Development',
      details: 'Possesses strong software development skills, honed through practical experience.',
      level: 7
    },
    {
      skill: 'HTML & CSS',
      details: 'Solid skills in HTML and CSS, allowing the creation of well-structured, visually appealing, and responsive web pages.',
      level: 4
    },
    {
      skill: 'Software Engineering',
      details: 'Possesses a good skill in team work to manage development in software.',
      level: 7
    },
    {
      skill: 'React Native',
      details: 'Fundamental skills in React Native for making responsive mobile applications.',
      level: 3
    },
    {
      skill: 'Azure DevOps',
      details: 'Practical experienced in development collaboration using Azure DevOps to run scrum lifecycle.',
      level: 5
    },
    {
      skill: 'ASP.NET',
      details: 'Fundamental skills in back end development using ASP.NET.',
      level: 5
    },
    {
      skill: 'Git',
      details: 'Implemented Git to manage the state of applications, particularly in complex projects requiring a predictable state container.',
      level: 7
    },
    {
      skill: 'Laravel',
      details: 'Fundamental skills in back end development with Laravel.',
      level: 6
    },
    {
      skill: 'Flask',
      details: 'Fundamental skill integrating AI Live Shopping to OBS Studio Socket with Flask',
      level: 5
    },
  ];